import React from "react";
import { FiClock } from "react-icons/fi";

const ScheduleComponent = ({ events }) => {
  return (
    events?.length > 0 && (
    <div className="mx-4 my-2">
  <h2 className="text-lg font-semibold mb-2">Event Schedule</h2>

  {/* Header (only for desktop) */}
  <hr className="block md:hidden border-gray-400" />
  <div className="hidden md:grid grid-cols-3 items-center py-2 border-b bg-[#F1F2FA] text-sm font-semibold text-left rounded-lg">
    <div className="pl-2">Timing</div>
    {events[0]?.eventTopic ? <div>Event Topic</div> : <div></div>}
    <div className="text-right mr-6">Speaker</div>
  </div>

  {events?.map((event, idx) => (
    <div
      key={idx}
      className="grid grid-cols-2 md:grid-cols-3 items-center py-4 border-b border-gray-400 text-sm gap-4"
    >
      {/* Time */}
      <div className="flex items-center gap-1 pl-2 ">
        <FiClock size={18} className="text-[#CF4C9B]" />
        <span>{event?.times}</span>
      </div>

      {/* Event Topic */}
      <div className="text-[#CF4C9B]  hidden md:flex ">{event?.eventTopic}</div>

      {/* Speaker Section */}
      <div className="flex items-center   justify-end gap-2 text-right">
        {/* Guest Name + Role */}
        <div className="flex flex-col text-sm text-right">
          {event.guestDetail?.map((item, gIdx) => (
            <div
              key={gIdx}
              className="whitespace-nowrap   overflow-hidden"
            >
              <h4 className="font-semibold">{item?.guestName}</h4>
              <p className="text-gray-600">{item?.role}</p>
            </div>
          ))}
        </div>

        {/* Speaker Image */}
        {event.image && (
          <div className="flex-shrink-0 w-[60px] h-[60px] border-2 rounded-full overflow-hidden">
            <img
              src={event.image}
              alt={event?.name}
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
    </div>
  ))}
</div>

    )
  );
};

export default ScheduleComponent;
